import { Controller } from "@hotwired/stimulus"
import {
  PENDING_REFRESH_KEY,
  restoreAllFormSelections
} from "../pick_selection_storage"

export default class extends Controller {
  connect() {
    restoreAllFormSelections()

    this.refreshTimeout = null
    this.boundOnVisibilityChange = this.onVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundOnVisibilityChange)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.boundOnVisibilityChange)
    if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout)
  }

  onVisibilityChange() {
    if (document.visibilityState !== "visible") return
    if (!sessionStorage.getItem(PENDING_REFRESH_KEY)) return

    if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout)
    this.refreshTimeout = window.setTimeout(() => this.refresh(), 300)
  }

  refresh() {
    sessionStorage.removeItem(PENDING_REFRESH_KEY)
    const url = window.location.href

    if (window.Turbo?.visit) {
      window.Turbo.visit(url, { action: "replace" })
      return
    }

    window.location.reload()
  }
}
